import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import PoolCard from "@/components/PoolCard";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Favorites() {
  const { t, user, loading } = useApp();
  const nav = useNavigate();
  const [pools, setPools] = useState([]);
  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/auth"); return; }
    api.get("/favorites").then((r) => setPools(r.data));
  }, [user, loading, nav]);
  if (!user) return null;
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-11 h-11 rounded-full bg-[#E27B58]/15 flex items-center justify-center"><Heart className="w-5 h-5 fill-[#E27B58] text-[#E27B58]" /></div>
        <div>
          <div className="overline text-[#E27B58]">{t("favorites.badge")}</div>
          <h1 className="font-display text-4xl font-bold">{t("favorites.title")}</h1>
        </div>
      </div>
      {pools.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-border rounded-2xl">
          <p className="text-muted-foreground mb-4">{t("favorites.empty")}</p>
          <Link to="/search"><Button className="rounded-full bg-[#005C7A]">{t("nav.search")}</Button></Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {pools.map((p) => <PoolCard key={p.pool_id} pool={p} />)}
        </div>
      )}
    </div>
  );
}
